import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Check } from "lucide-react";
import { formatPrice } from "@/lib/currency";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => { api.get(`/orders/${id}`).then((r) => setOrder(r.data)).catch(() => {}); }, [id]);

  return (
    <div data-testid="order-success-page" className="max-w-2xl mx-auto px-6 py-32 text-center">
      <div className="w-16 h-16 mx-auto rounded-full bg-[#C5A059] text-white flex items-center justify-center"><Check size={28} /></div>
      <div className="overline mt-8">Order confirmed</div>
      <h1 className="serif text-5xl mt-4">Thank you.</h1>
      <p className="text-[#5A5A5A] mt-4">Your order #{id.slice(0, 8)} has been received. We'll email a tracking link as soon as it ships.</p>
      {order && (
        <div className="mt-12 text-left border border-[#E5E5DF] p-6">
          <div className="overline">Summary</div>
          <div className="mt-4 space-y-2 text-sm">
            {order.items.map((i, idx) => (
              <div key={idx} className="flex justify-between"><span>{i.name} ×{i.quantity}</span><span>{formatPrice(i.total)}</span></div>
            ))}
          </div>
          <div className="flex justify-between mt-4 pt-4 border-t border-[#E5E5DF] serif text-xl"><span>Total</span><span>{formatPrice(order.total)}</span></div>
        </div>
      )}
      <Link to="/shop" className="btn-outline mt-12 inline-flex" data-testid="continue-shopping">Continue shopping</Link>
    </div>
  );
}
